
const RESTRICTED_SIGNING_TYPES = ['MANUAL'];

const updateSignings = signings => signings
    ?.filter(s => !RESTRICTED_SIGNING_TYPES.includes(s.type))
    .map(s => ({
      ...s,
      ...(s.type === 'AUTOMATIC_DISCOUNTGROUP' && s?.alternativeLabel && {label: s.alternativeLabel})
    }));

const handlePersonalisedPrice = (product) => {
  const { membersOnlyPriceEnabled } = AppSettings;
  const isLoggedIn = AppState?.userMetaData?.loggedInStatus;

  if (!membersOnlyPriceEnabled) {
    return {
      ...product,
      signings: product?.signings?.filter(s => !s?.membersOnlySigning)
    };
  }

  const isPersonalizedPriceApplied = Boolean(isLoggedIn && product?.personalisedPrice);
  const isPersonalizedLabelApplied = Boolean(!isLoggedIn && product?.personalisedPrice);

  return {
    ...product,
    ...(isPersonalizedPriceApplied && { price: product?.personalisedPrice ?? product?.price }),
    ...(isPersonalizedLabelApplied && {
      signings: updateSignings(product?.signings) ?? product?.signings,
    }),
  };
};

export default handlePersonalisedPrice;
